import kamala from '../../kamala'
import Radio from './Radio'
import RadioGroup from './RadioGroup'
import RadioButton from './RadioButton'

const KRadioFamily = {
  install: function (Vue) {
    kamala(Vue)

    Vue.component(Radio.name, Radio)
    Vue.component(RadioGroup.name, RadioGroup)
    Vue.component(RadioButton.name, RadioButton)
  },
  KRadio: Radio,
  KRadioGroup: RadioGroup,
  KRadioButton: RadioButton,
}

export { Radio, RadioGroup, RadioButton }

export default KRadioFamily
